import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { useNativeSharingModal } from "@/hooks/nativeSharing";
import { useCurrentUser } from "@/hooks/user";
import DesktopShare from "./DesktopShare";
import MobileNativeShare from "./MobileNativeShare";
import styles from "./socialShare.module.scss";

const SocialShare = ({ title, className }) => {
  const { user, isLoggedIn } = useCurrentUser();
  const params = new URLSearchParams(location.search.replace(/^\?/, ""));
  params.set("utm_campaign", "sep_referral");

  if (isLoggedIn) {
    params.set("utm_content", user?.pid);
  } else {
    params.set("utm_term", "anon");
  }

  const url = `${location.href}?${params}`;
  const encodedUrl = encodeURIComponent(url);
  const { isMobileAndNativeSharingAvailable } = useNativeSharingModal({ onError });
  const onError = () => console.log("Mobile native sharing is not supported");

  return (
    <div className={cx(styles.socialLinks, className)}>
      {
        isMobileAndNativeSharingAvailable
          ? <MobileNativeShare url={url} title={title} onError={onError} />
          : <DesktopShare url={url} encodedUrl={encodedUrl} />
      }
    </div>
  );
};

export default SocialShare;

SocialShare.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string
};
